import React, { Component } from "react";

import { Container } from "reactstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import {
  getAllCampaignAppsList,
  getAllCampaignClientList,
  getAllCampaignDirectionTypeProfileList,
  getAllCampaignFormatProfileList,
  getAllCampaignMediaBuyerProfileList,
  getAllCampaignOfferTypeProfileList,
  getAllCampaignSourceProfileList,
  getAllCampaignStatusProfileList,
  getCampaign,
  setCampaignError,
  updateCampaignProfile
} from "../../../store/campaigns/campaign-info/actions";
import CampaignInfoBlock from "./components/CampaignInfoBlock";
import CampaignParamsBlock from "./components/CampaignParamsBlock";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class CampaignInfo extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getCampaign(this.props.match.params.campaignId);
    //this.props.getAllCampaignClientList();
    this.props.getAllCampaignAppsList();
    this.props.getAllCampaignOfferTypeProfileList();
    this.props.getAllCampaignSourceProfileList();
    this.props.getAllCampaignDirectionTypeProfileList();
    this.props.getAllCampaignStatusProfileList();
    this.props.getAllCampaignMediaBuyerProfileList();
    this.props.getAllCampaignFormatProfileList();
  }

  componentWillUnmount() {
    this.props.setCampaignError(false);
  }

  render() {
    const data = this.props.data;
    const isError = this.props.isError;

    if (isError) {
      return (
        <Redirect to={"/404"} />
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Campaign | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Campaigns" breadcrumbItem={this.props.data?.campaign_name} link="/campaigns" />
            <CampaignInfoBlock data={data} />
            <CampaignParamsBlock data={data}
                                 campaignId={this.props.match.params.campaignId}
                                 campaignData={this.props.campaignData}
                                 updateCampaignProfile={this.props.updateCampaignProfile}
                                 clientData={this.props.clientData}
                                 appData={this.props.appData}
                                 offerTypeData={this.props.offerTypeData}
                                 sourceData={this.props.sourceData}
                                 directionTypeData={this.props.directionTypeData}
                                 statusData={this.props.statusData}
                                 mediaBuyerData={this.props.mediaBuyerData}
                                 formatData={this.props.formatData}
                                 history={this.props.history}
                                 permissions={this.props.permissions}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CampaignInfo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      campaignId: PropTypes.node
    }).isRequired
  }).isRequired,
  getCampaign: PropTypes.func,
  setCampaignError: PropTypes.func,
  getAllCampaignClientList: PropTypes.func,
  getAllCampaignAppsList: PropTypes.func,
  getAllCampaignOfferTypeProfileList: PropTypes.func,
  getAllCampaignSourceProfileList: PropTypes.func,
  getAllCampaignDirectionTypeProfileList: PropTypes.func,
  getAllCampaignStatusProfileList: PropTypes.func,
  getAllCampaignMediaBuyerProfileList: PropTypes.func,
  getAllCampaignFormatProfileList: PropTypes.func,
  updateCampaignProfile: PropTypes.func,
  data: PropTypes.any,
  isError: PropTypes.any,
  clientData: PropTypes.any,
  appData: PropTypes.any,
  offerTypeData: PropTypes.any,
  sourceData: PropTypes.any,
  directionTypeData: PropTypes.any,
  statusData: PropTypes.any,
  mediaBuyerData: PropTypes.any,
  formatData: PropTypes.any,
  campaignData: PropTypes.any,
  history: PropTypes.any,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.CampaignInfo.data,
  isError: state.CampaignInfo.isError,
  clientData: state.CampaignInfo.clientData,
  appData: state.CampaignInfo.appData,
  offerTypeData: state.CampaignInfo.offerTypeData,
  sourceData: state.CampaignInfo.sourceData,
  directionTypeData: state.CampaignInfo.directionTypeData,
  statusData: state.CampaignInfo.statusData,
  mediaBuyerData: state.CampaignInfo.mediaBuyerData,
  formatData: state.CampaignInfo.formatData,
  campaignData: state.CampaignsList.data,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    getCampaign,
    setCampaignError,
    getAllCampaignClientList,
    getAllCampaignAppsList,
    getAllCampaignOfferTypeProfileList,
    getAllCampaignSourceProfileList,
    getAllCampaignDirectionTypeProfileList,
    getAllCampaignStatusProfileList,
    getAllCampaignMediaBuyerProfileList,
    getAllCampaignFormatProfileList,
    updateCampaignProfile
  })(CampaignInfo)
);
